import React from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";

export default function ProjectSharingSkeleton({ rows = 5 }) {
  return [...Array(rows)].map((_, index) => (
    <TableRow key={`skeleton-${index}`}>
      <TableCell>
        <Skeleton variant="text" width={200} height={24} />
      </TableCell>
      <TableCell>
        <Box display="flex" justifyContent="flex-end">
          <Skeleton variant="circular" width={32} height={32} />
        </Box>
      </TableCell>
    </TableRow>
  ));
}
